module.exports = __webpack_public_path__ + "img/1-3.f698bb29.svg";